import { useEffect } from "react";
import { Link } from "react-router-dom";

const BRANDS = [
  ["Harvia", "harvia"], ["Kohler", "kohler"], ["Dundalk LeisureCraft", "leisurecraft"],
  ["HealthSmart", "healthsmart"], ["Finnmark Designs", "finnmark-designs"],
  ["MandeSpa", "mandespa"], ["SaunaLife", "saunalife"], ["ThermaSol", "thermasol"],
  ["Saunum", "saunum"], ["HUKKA", "hukka"], ["Cozy Heat", "cozy-heat"],
  ["KOLO", "kolo"], ["Narvi", "narvi"],
];

export default function BrandsIndex() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="pt-16" data-testid="brands-index-page">
      <div className="bg-charcoal border-b border-white/10">
        <div className="max-w-[1200px] mx-auto px-5 lg:px-10 py-14">
          <p className="overline">Our Brands</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-cream mt-2">Shop by Brand</h1>
          <p className="text-cream/65 mt-3 max-w-2xl">An authorized dealer for the finest names in wellness.</p>
        </div>
      </div>
      <div className="max-w-[1200px] mx-auto px-5 lg:px-10 py-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {BRANDS.map(([name, handle]) => (
          <Link key={handle} to={`/shop/c/${handle}`} data-testid={`brand-tile-${handle}`}
            className="group flex items-center justify-center text-center bg-charcoal border border-white/10 hover:border-gold/40 transition-all duration-300 hover:-translate-y-1 aspect-[3/2] px-4">
            <span className="font-serif text-xl text-cream group-hover:text-gold transition-colors">{name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
